import React, { useEffect, useState } from 'react'
import { withUserStore } from '../../contexts/UserStore'
import { Input, Label } from '@byscott-io/corebyscott'
import PageView from './PageView'
import Lex from '../Shared/Lex'
import PageProvider from '../../modules/PageProvider'

const Accounts = ({ userStore }) => {
  const [switchingToAccountId, setSwitchingToAccountId] = useState(null)
  useEffect(() => {
    if (userStore.account?.id === userStore.accountId && userStore.accountId === switchingToAccountId) {
      setSwitchingToAccountId(null)
      userStore.appNavigate()
    }
  }, [userStore.account?.id, userStore.accountId, switchingToAccountId]);
  const switchAccounts = id => {
    setSwitchingToAccountId(id)
    userStore.switchAccounts(id)
  }

  const form = {}

  const page = {
    click: (record) => switchAccounts(record.id),
    formName: () => 'Organization Memberships',
    recordType: () => 'accounts',
    pageHeader: () => <span><h3 className="inline-block">Organization Memberships</h3></span>,
    newRecord: () => {
      return { name: '', accountType: 'Business' }
    },
    records: () => {
      return userStore.user && userStore.accounts?.sort((a, b) => ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0)) || []
    },
    formFields: (record) => {
      //    if (record == null) record = { name: '', description: '' }
      record = record || { name: '', description: '' }
      return <div><Label><Lex term="name" /></Label><Input innerRef={el => form.name = el} defaultValue={record.name} />
        <br />
        <Label><Lex term="description" /></Label><Input
          innerRef={el => form.description = el}
          defaultValue={record.description}
        />
      </div>
    },
    saveRecord: (record) => {
      record.name = form.name.value
      record.description = form.description.value
      if (record.id) { userStore.updatePriority(record) } else { userStore.createPriority(record.name, record.description, userStore.account?.id) }
      return true
    },
    destroy: (record) => userStore.destroyPriority(record)
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Accounts)
